import { ColDef } from 'ag-grid-community';
import { Client } from '../../../../../core/domainModels/clients/Client';
import { assignColDefsDefaults, COLUMN_WIDTH, fieldName } from '../../../../../core/helpers/aggrid';
import { TachoColumnState } from '../../../../../core/domainModels/displayPreferences/tachoColumnState';
import { ColumnTooltip } from '../../../../components/TachoTooltip/columnTooltip';
import { eyeRendererIcon } from '../../../../components/AgGrid/Renderers/TableRemoveButton/icons';

export const clientsTableDefaultColumnsDefs: ColDef = {
    sortable: true,
    resizable: true,
    tooltipComponent: ColumnTooltip,
    sortingOrder: ['asc', 'desc', null],
};

export const clientsTableColumnsDefinitions = (
    formatMessage: ({ id }: { id: string }) => string,
    licencesModalOpen: (isModalOpen: boolean, data?: Client) => void,
    defColumnState: Array<TachoColumnState>,
): Array<ColDef> => {
    const columns: Array<ColDef> = [
        {
            colId: fieldName<Client>('name'),
            headerName: formatMessage({ id: 'clientName' }),
            headerTooltip: formatMessage({ id: 'clientName' }),
            field: fieldName<Client>('name'),
            initialWidth: COLUMN_WIDTH.XL,
        },

        {
            colId: fieldName<Client>('nip'),
            headerName: formatMessage({ id: 'clientNip' }),
            headerTooltip: formatMessage({ id: 'clientNip' }),
            field: fieldName<Client>('nip'),
            initialWidth: COLUMN_WIDTH.SM,
        },
        {
            colId: fieldName<Client>('country'),
            headerName: formatMessage({ id: 'clientCountry' }),
            headerTooltip: formatMessage({ id: 'clientCountry' }),
            field: fieldName<Client>('country'),
            initialWidth: COLUMN_WIDTH.MD,
        },
        {
            colId: fieldName<Client>('email'),
            headerName: formatMessage({ id: 'clientEmail' }),
            headerTooltip: formatMessage({ id: 'clientEmail' }),
            field: fieldName<Client>('email'),
            initialWidth: COLUMN_WIDTH.XL,
        },
        {
            colId: fieldName<Client>('phoneNumber'),
            headerName: formatMessage({ id: 'clientPhoneNumber' }),
            headerTooltip: formatMessage({ id: 'clientPhoneNumber' }),
            field: fieldName<Client>('phoneNumber'),
            initialWidth: COLUMN_WIDTH.SM,
        },
        {
            colId: fieldName<Client>('city'),
            headerName: formatMessage({ id: 'clientCity' }),
            headerTooltip: formatMessage({ id: 'clientCity' }),
            field: fieldName<Client>('city'),
            initialWidth: COLUMN_WIDTH.MD,
        },
        {
            colId: fieldName<Client>('zipCode'),
            headerName: formatMessage({ id: 'clientZipCode' }),
            headerTooltip: formatMessage({ id: 'clientZipCode' }),
            field: fieldName<Client>('zipCode'),
            initialWidth: COLUMN_WIDTH.XS,
        },
        {
            colId: fieldName<Client>('street'),
            headerName: formatMessage({ id: 'clientStreet' }),
            headerTooltip: formatMessage({ id: 'clientStreet' }),
            field: fieldName<Client>('street'),
            initialWidth: COLUMN_WIDTH.LG,
        },
        {
            colId: fieldName<Client>('houseNumber'),
            headerName: formatMessage({ id: 'clientHouseNumber' }),
            headerTooltip: formatMessage({ id: 'clientHouseNumber' }),
            field: fieldName<Client>('houseNumber'),
            initialWidth: COLUMN_WIDTH.SM,
        },

        {
            colId: fieldName<Client>('apartamentNumber'),
            headerName: formatMessage({ id: 'clientApartmentNumber' }),
            headerTooltip: formatMessage({ id: 'clientApartmentNumber' }),
            field: fieldName<Client>('apartamentNumber'),
            initialWidth: COLUMN_WIDTH.SM,
        },
        {
            colId: fieldName<Client>('notes'),
            headerName: formatMessage({ id: 'clientNotes' }),
            headerTooltip: formatMessage({ id: 'clientNotes' }),
            field: fieldName<Client>('notes'),
            initialWidth: COLUMN_WIDTH.MD,
        },
        {
            colId: '12',
            headerName: formatMessage({ id: 'licencesPage' }),
            headerTooltip: formatMessage({ id: 'licencesPage' }),
            field: 'licences',
            flex: 1,
            minWidth: COLUMN_WIDTH.XS,
            cellRenderer: 'tableButtonRenderer',
            cellRendererParams: (params: any) => {
                return {
                    onClick: () => licencesModalOpen(true, params.data),
                    disabled: () => {},
                    icon: eyeRendererIcon,
                };
            },
            filter: false,
        },
    ];
    assignColDefsDefaults(columns, defColumnState, true);
    return columns;
};
